import * as React from "react"
import { LoginForm } from "../components/login/LoginForm"

export const Login = ()=>{
    return(
        <div>
            <LoginForm/>
        </div>
    )
}